import React, { FC } from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { ISocialLanguage } from '@src/types/resumeDetail/socialType';
import { ICampusLanguage } from '@/src/types/resumeDetail/campusType';
import './index.scss';

interface IProps {
  data: ISocialLanguage[] | ICampusLanguage[];
  type: string;
  setMode: Function;
}

// 社校共用
const LanguageStandardView: FC<IProps> = (props) => {
  const { data, type, setMode } = props;
  const { campusResumeFormRefStore, socialResumeFormRefStore } = useRootStore();
  let storeRef;
  if (type === 'campus') {
    storeRef = campusResumeFormRefStore;
  }
  if (type === 'social') {
    storeRef = socialResumeFormRefStore;
  }

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('language_standard_edit');
  };

  return (
    <div className="language_standard_view model_view">
      <div className="model_title" onClick={() => handleEdit()}>
        <div>语言水平</div>
        <div className="edit_icon">
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      <div className="model_main">
        {data?.map((item) => (
          <div className="model_list" key={item.renderId}>
            <span className="language_name">
              <span>{item.languageName}</span>
            </span>
            <span className="center">|</span>
            <span className="language_level">
              <span>{item.levelName}</span>
            </span>
            {item?.language === 'English' && type === 'campus' ? (
              <>
                {item?.examinationName ? <span className="center">|</span> : null}
                <span className="language_level">
                  <span>{item?.examinationName}</span>
                </span>
                {item?.score ? <span className="center">|</span> : null}
                <span className="language_level">
                  <span>{item?.score}</span>
                </span>
              </>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LanguageStandardView;
